(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vueto-completet"] = factory();
	else
		root["vueto-completet"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 